const NotFoundPage = () => (
  <>This page is not available</>
);
export default NotFoundPage;
